import { render, staticRenderFns } from "./Replenishment.vue?vue&type=template&id=65907ece"
import script from "./Replenishment.vue?vue&type=script&lang=js"
export * from "./Replenishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports